module.exports = __webpack_public_path__ + "images/d3864fe4ef1ba216c187c43068e937bc-bgTexture.png";